"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.left = exports.right = exports.Either = void 0;
class Either {
    constructor(leftValue, rightValue) {
        this.rightMap = (callback) => {
            if (this.rightValue !== undefined) {
                callback(this.rightValue);
            }
            return this;
        };
        this.leftMap = (callback) => {
            if (this.leftValue !== undefined) {
                callback(this.leftValue);
            }
            return this;
        };
        this.leftValue = leftValue;
        this.rightValue = rightValue;
    }
}
exports.Either = Either;
class Right extends Either {
    constructor(value) {
        super(undefined, value);
    }
}
class Left extends Either {
    constructor(value) {
        super(value, undefined);
    }
}
const right = (value) => {
    return new Right(value);
};
exports.right = right;
const left = (value) => {
    return new Left(value);
};
exports.left = left;
//# sourceMappingURL=either.js.map